import * as THREE from 'three'
import { physicsToThree } from './scene.js'
import type { Ball } from '../physics/ball.js'

/** Colours for each ball (Bamford = blue, future: red/yellow/black) */
export const BALL_COLORS = {
  bamford: 0x3366cc,
  nasr: 0xcc3333,
}

export class BallMesh {
  mesh: THREE.Mesh
  private _rotation = 0

  constructor(color: number, scene: THREE.Scene) {
    const geo = new THREE.SphereGeometry(1, 16, 12)  // radius 1, scaled at placement
    const mat = new THREE.MeshLambertMaterial({ color })
    this.mesh = new THREE.Mesh(geo, mat)
    this.mesh.castShadow = true

    // Spot on ball to show rotation (a small lighter disc on top)
    const dotGeo = new THREE.CircleGeometry(0.25, 8)
    const dotMat = new THREE.MeshLambertMaterial({ color: 0xffffff, opacity: 0.4, transparent: true })
    const dot = new THREE.Mesh(dotGeo, dotMat)
    dot.rotation.x = -Math.PI / 2
    dot.position.y = 1.01
    this.mesh.add(dot)

    scene.add(this.mesh)
  }

  update(ball: Ball): void {
    const visualRadius = ball.radius * 1.2   // slightly larger than physics for visibility
    const pos = physicsToThree(ball.pos.x, ball.pos.y, visualRadius)
    this.mesh.position.copy(pos)
    this.mesh.scale.setScalar(visualRadius)

    // Rotate based on angular velocity (visual feedback that physics is working)
    this._rotation += ball.angularVel * 0.016
    this.mesh.rotation.y = this._rotation
  }

  setVisible(visible: boolean): void {
    this.mesh.visible = visible
  }
}
